import { Action } from './action';

export class ClearBrokerDetails extends Action {}
